import React from 'react';
import LockedInit from '../../components/student-password-reset-section/LockedInitialization';

const Locked = (props) => (
    <LockedInit {...props} />
);

export default Locked;